class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange(e) {
      this.updateOptions();
      this.currentVariant();
      this.updateVaraintImage(e.target);
      this.updateVariantId()
      this.updatePrice();
      this.availabality();
    }
  
    getVariantData() {
      return JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      );
    }
  
    updateOptions() {
      const selectedOptions = [];
      [...this.querySelectorAll('select, input')].map((element) => {
        if (element.tagName === 'SELECT') {
          return element; 
        } else if (element.type === 'radio' && element.checked) {
          return element; 
        }
        return null; 
      }).filter(element => {
        if(element !== null) {
          let position = Number(element.getAttribute('data-option-position'));
          selectedOptions[position - 1] = element.value;
        }
      });
      return selectedOptions;
    }  
  
    updateVaraintImage() {
      const currentVariant = this.currentVariant();
      const variantImgEl = this.closest('[js-product-card]').querySelector("[js-variant-image-wrapper] img");

      if(bundleProductVariantCustomDatas[currentVariant.id]?.alternateImage) {
        if(variantImgEl) {
          variantImgEl.setAttribute("src", bundleProductVariantCustomDatas[currentVariant.id].alternateImage);
          variantImgEl.setAttribute("srcset", bundleProductVariantCustomDatas[currentVariant.id].alternateImage);
          variantImgEl.setAttribute("data-srcset", bundleProductVariantCustomDatas[currentVariant.id].alternateImage);
        }
      } else {
        if(variantImgEl && currentVariant.featured_image?.src) {
          variantImgEl.setAttribute("src", currentVariant.featured_image?.src);
          variantImgEl.setAttribute("srcset", currentVariant.featured_image?.src);
          variantImgEl.setAttribute("data-srcset", currentVariant.featured_image?.src);
        }
      }
    }
  
    currentVariant() {
      const options = this.updateOptions();
      return this.getVariantData().find((variant) => {
        const match = !variant.options.map((option, index) => {
          const isMatch = options[index] === option;
          return isMatch;
        }).includes(false);
        return match;
      });
    }

    availabality() {
      const variantsData = this.getVariantData();
      const currentVariant = this.currentVariant();

      const customDropdownLis = document.querySelectorAll('custom-dropdown .select-options li');

      customDropdownLis.forEach(option => {
        const position  = parseInt(option.getAttribute("data-option-position"));
        const optionValue = option.getAttribute("data-option-value");
        variantsData.forEach(variant => {
          if (variant.available && optionValue === variant[`option${position}`] && variant.id == currentVariant.id) {
            option.removeAttribute('disabled');
          } 
          if (variant.available === false && optionValue === variant[`option${position}`] && variant.id == currentVariant.id) {
            option.setAttribute('disabled', true);
          }
        })
      })
      
    }

    updateVariantId() {
        const currentVariant = this.currentVariant();
        const parent = this.closest('[js-product-card]');
        const productId = parent.getAttribute('data-product-id');
        const position = parent.getAttribute('data-position');
        const bundleData = window.bundleProductVariantCustomDatas?.[currentVariant.id];

        if (bundleData && bundleData.bundleChildren && bundleData.bundleChildren.length) {
          this.applyBundleChildExpansion(currentVariant, bundleData, productId, position);
        } else {
          this.clearBundleChildExpansion(productId, position);

          const variantIdInputs = document.querySelectorAll(`product-bundle [data-input-variant-id="${productId}_${position}"]`)
          const variantDiscountInputs = document.querySelectorAll(`product-bundle [name="items[${+position + 1}][properties[_pamo_bundle_discount]]"]`)

          variantIdInputs.forEach(input => {
            input.setAttribute('value', currentVariant.id)
          })

          if(currentVariant.compare_at_price) {
            variantDiscountInputs.forEach(input => {
              input.setAttribute('value', 0)
            })
          } else {
            variantDiscountInputs.forEach(input => {
              input.setAttribute('value', bundleInfo.discount)
            })
          }
        }

        this.updateQuantity();
        this.updateDeliveryDate(currentVariant);
    }

    // A child product in the bundle can itself be configured as a bundle variant
    // (variant.metafields.custom.bundle_variant). In that case the single
    // items[N] slot rendered for this position must be superseded by one line
    // item per child variant, mirroring how BundleVariantOptionApp expands the
    // main product form in custom.js.
    applyBundleChildExpansion(currentVariant, bundleData, productId, position) {
        const bundleProductEl = this.closest('product-bundle');
        const form = bundleProductEl.querySelector('[js-form]');
        const isActive = this.closest('[js-product-card]').classList.contains('active');
        const positionKey = `${productId}_${position}`;

        bundleProductEl.querySelectorAll(`[data-bundle-expanded-position="${positionKey}"]`).forEach(el => el.remove());
        bundleProductEl.querySelectorAll(`[data-input-product-id="${positionKey}"]`).forEach(field => {
          field.setAttribute('data-bundle-locked', 'true');
          field.disabled = true;
        });

        let bundleId = `bundle-${currentVariant.id}-children-`;
        let bundleRecipe = '{';
        bundleData.bundleChildren.forEach((entry, index) => {
          bundleId += `${entry.quantity}_${entry.variant.id}_`;
          bundleRecipe += `"gid://shopify/ProductVariant/${entry.variant.id}":${entry.quantity}`;
          if (index < bundleData.bundleChildren.length - 1) bundleRecipe += ',';
        });
        bundleRecipe += '}';

        const discount = currentVariant.compare_at_price ? 0 : (window.bundleInfo?.discount || 0);
        let itemIndex = this.getNextItemIndex(form);

        bundleData.bundleChildren.forEach((entry, index) => {
          const fields = {
            [`items[${itemIndex}][id]`]: entry.variant.id,
            [`items[${itemIndex}][quantity]`]: entry.quantity,
            [`items[${itemIndex}][properties][_bundle_id]`]: bundleId,
            [`items[${itemIndex}][properties][_bundle_parent_variant]`]: currentVariant.id,
            [`items[${itemIndex}][properties][_bundle_recipe]`]: bundleRecipe,
            [`items[${itemIndex}][properties][_bundle_parent_price]`]: bundleData.bundlePrice / 100.0,
            [`items[${itemIndex}][properties][_bundle_role]`]: 'child',
            [`items[${itemIndex}][properties][_bundle_index]`]: index,
            [`items[${itemIndex}][properties[_pamo_bundle_product]]`]: 'true',
            [`items[${itemIndex}][properties[_pamo_bundle_discount]]`]: discount,
            [`items[${itemIndex}][properties[_pamo_bundle_item_quantity]]`]: entry.quantity,
          };

          Object.entries(fields).forEach(([name, value]) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            input.setAttribute('data-input-product-id', positionKey);
            input.setAttribute('data-bundle-expanded-position', positionKey);
            input.disabled = !isActive;
            form.appendChild(input);
          });

          const bundleIdInput = document.createElement('input');
          bundleIdInput.type = 'hidden';
          bundleIdInput.name = `items[${itemIndex}][properties[_pamo_bundle_id]]`;
          bundleIdInput.setAttribute('js-bundle-id', '');
          bundleIdInput.setAttribute('data-input-product-id', positionKey);
          bundleIdInput.setAttribute('data-bundle-expanded-position', positionKey);
          bundleIdInput.disabled = !isActive;
          form.appendChild(bundleIdInput);

          itemIndex++;
        });
    }

    getNextItemIndex(form) {
        let maxIndex = 0;
        form.querySelectorAll('[name^="items["]').forEach(field => {
          const match = field.name.match(/^items\[(\d+)\]/);
          if (match) {
            const index = parseInt(match[1], 10);
            if (index > maxIndex) maxIndex = index;
          }
        });
        return maxIndex + 1;
    }

    clearBundleChildExpansion(productId, position) {
        const bundleProductEl = this.closest('product-bundle');
        const positionKey = `${productId}_${position}`;

        bundleProductEl.querySelectorAll(`[data-bundle-expanded-position="${positionKey}"]`).forEach(el => el.remove());

        const isActive = this.closest('[js-product-card]').classList.contains('active');
        bundleProductEl.querySelectorAll(`[data-input-product-id="${positionKey}"]`).forEach(field => {
          field.removeAttribute('data-bundle-locked');
          field.disabled = !isActive;
        });
    }

    updateQuantity() { 
      const parent = this.closest('product-bundle');
      const itemidInputs = parent.querySelectorAll('[js-item-id-input]');
      let quantity = 0;

      itemidInputs.forEach(input => {
        const variantId = input.value;
        const productId = input.getAttribute('data-item-id');
        const sameVarantArrayLength = parent.querySelectorAll(`[js-item-id-input][value="${variantId}"]`)?.length;

        if(quantity < sameVarantArrayLength) {
          quantity = sameVarantArrayLength;
          parent.querySelectorAll(`[js-item-quantity-input][data-item-id="${productId}"]`)?.forEach(quantityInput => {
            quantityInput.value = quantity;
          })
        }

      })
    }

    updateDeliveryDate(currentVariant) {
      const parent = this.closest('[js-product-card]');
      const deliveryDateTag = parent.querySelector('[js-bundle-delivery-wrappery]');
      if(deliveryDateTag && bundleProductVariantCustomDatas[currentVariant.id]) {
        deliveryDateTag.innerHTML = `* ${bundleProductVariantCustomDatas[currentVariant.id].availibilityText}`;
      }
    }

    updatePrice() {
      const bundleInfo = window.bundleInfo;
      const currentVariant = this.currentVariant();
      const parent = this.closest('[js-product-card]');
      parent.setAttribute('data-current-variant-price', currentVariant.price)
      parent.setAttribute('data-current-variant-compare-at-price', currentVariant.compare_at_price || '');

      const productCards = this.closest('product-bundle').querySelectorAll('.active[js-product-card]');
      let bundleOriginalPrice = bundleInfo.mainProductPrice;

      let mainProductDiscountedPrice =  ((100 - bundleInfo.discount) / 100 * bundleInfo.mainProductPrice);
      let mainChildBundleProductsDiscountedPrice = 0;

      if(bundleInfo.mainProductCompareAtPrice) {
          bundleOriginalPrice = bundleInfo.mainProductCompareAtPrice;
          mainProductDiscountedPrice = bundleInfo.mainProductPrice;
      }

      productCards.forEach(productCard => {
        const variantPrice = parseFloat(productCard.getAttribute('data-current-variant-price')); 

        let variantCompareAtPrice = 0;

        if(productCard.getAttribute('data-current-variant-compare-at-price')) {
          variantCompareAtPrice = parseFloat(productCard.getAttribute('data-current-variant-compare-at-price'));
        }
        
        if(variantCompareAtPrice) {
          bundleOriginalPrice += variantCompareAtPrice;
          mainChildBundleProductsDiscountedPrice += variantPrice;
        } else {
          bundleOriginalPrice += variantPrice;
          mainChildBundleProductsDiscountedPrice += ((100 - bundleInfo.discount) / 100 * variantPrice);
        }
        
      })

      let bundleDiscountPrice = mainProductDiscountedPrice + mainChildBundleProductsDiscountedPrice;

      const formatMoney = (val => this.closest('product-bundle').formatMoney(val, window.theme.moneyFormat || '${{amount}}'));

      document.querySelectorAll('[js-bundle-product-discounted-price]').forEach(priceTag => {
        priceTag.innerHTML = `${formatMoney(bundleDiscountPrice)}`
      })

      document.querySelectorAll('[js-bundle-product-original-price]').forEach(priceTag => {
          priceTag.innerHTML = `${formatMoney(bundleOriginalPrice)}`
      })
  
    }

  }
  
  customElements.define("variant-selects", VariantSelects);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('variant-selects').forEach(el => {
      el.updateVariantId();
    });
  });